import { render, staticRenderFns } from "./OrgListLogin.vue?vue&type=template&id=2d4545e8"
import script from "./OrgListLogin.vue?vue&type=script&lang=js"
export * from "./OrgListLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports